import {
    Card,
    Exercise,
    GhostButton,
    LabelBody,
    LabelHeader4,
    LabelHeader5,
} from '../../components';
import { ExerciseData, ExerciseViewProps } from '../../exercises';
import { IllustrationPersonWatchingTheSun } from '../../icons';
import { ExerciseStatus } from '../../interfaces';
import { openLogbook } from '../../nativeAPI';

export const exerciseData43: ExerciseData = {
    ExerciseView: Module4Exercise3,
    dataKeys: [],
    questions: [],
};

function Module4Exercise3({ onContinue }: ExerciseViewProps) {
    return (
        <Exercise title="Taknemmelighedsdagbog">
            <LabelHeader4>Få øje på det der spiller</LabelHeader4>
            <LabelBody className="mt-10">
                Når du har travlt eller er presset, kan det være svært at se det
                positive. Du ser måske mest det, der ikke virker.
            </LabelBody>
            <LabelBody>
                En taknemmelighedsdagbog kan hjælpe dig. Den får dig til at se
                det gode i din hverdag - de ting, der lykkes, og som du er glad
                for.
            </LabelBody>
            <IllustrationPersonWatchingTheSun className="mx-auto my-30" />
            <LabelBody>
                Ved at skrive tre ting ned hver dag, som du er taknemmelig for,
                træner du din hjerne til at lægge mærke til det positive noget
                oftere. Og her er det vigtige: Når du fokuserer på det, der gør
                dig glad og som du sætter pris på, bliver det tydeligere, hvad
                der virkelig betyder noget for dig i dit liv. Det hjælper dig
                med at bruge mere tid og energi på netop de ting, der stemmer
                overens med dine værdier.
            </LabelBody>
            <LabelBody className="mt-10">
                Se på det som et værktøj, som du sætter i spil her og nu, eller
                noget du hiver frem om lidt tid, når du har brug for at minde
                dig selv om de ting, der kører for dig.
            </LabelBody>
            <Card className="mt-30">
                <LabelHeader5>Nemt og effektfuldt</LabelHeader5>
                <LabelBody className="my-10">
                    I slutningen af hver dag: Skriv tre ting ned du er
                    taknemmelig for ved din dag. Det kan være småt som stort.
                </LabelBody>
                <LabelBody>
                    F.eks. en god frokost, eller en joke, der fik mig til at
                    grine.
                </LabelBody>
                <GhostButton
                    className="mt-20"
                    onClick={() => {
                        onContinue({
                            status: ExerciseStatus.Completed,
                            goToNext: openLogbook,
                        });
                    }}
                >
                    Gå til logbogen
                </GhostButton>
            </Card>
        </Exercise>
    );
}
